/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useEffect, useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/system";

import Icon from "@mui/material/Icon";
import LoopIcon from "@mui/icons-material/Loop";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftSelect from "components/SoftSelect";
import SoftButton from "components/SoftButton";

// Settings page components

// import BasicInfo from "./components/BasicInfo";
// import ChangePassword from "./components/ChangePassword";
// import DeleteAccount from "./components/DeleteAccount";

// react-router components

import { getData } from "Utils/server";
import { getAuthorizationHeader, getUserData } from "Utils/helpers";
import SoftInput from "components/SoftInput";
import SoftDatePicker from "components/SoftDatePicker";
let sportsList = [];

/**
 *
 */
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    //backgroundColor: "#f5f5f9",
    backgroundColor: "#000",
    color: "rgba(f, f, f, 1)", //"rgba(0, 0, 0, 0.87)",
    placement: "left",
    minWidth: "minContent",
    height: "minContent",
    textAlign: "left",
    fontSize: "0.65erm",
    border: "1px solid #dadde9",
    boxShadow: "0rem 1.25rem 1.6875rem 0rem rgba(0, 0, 0, 0.05)",
    padding: "15px",
    marginLeft: "15px",
  },
}));

function AdvancedSettlementFilters({
  applyFilters,
  settlementOutcomes,
  informParent,
  forceToggle,
  loadingData,
  preLoadFilters,
}) {
  const [betType, setBetType] = useState({ value: 0, label: "All", info: "" });
  const [betTypes, setBetTypes] = useState([]);
  const [filters, setFilters] = useState({});
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [outcomes, setOutcomes] = useState([]);
  const [customFixtureDate, setCustomFixtureDate] = useState(false);
  const [customBetDate, setCustomBetDate] = useState(false);
  const [customBetbuilderDate, setCustomBetbuilderDate] = useState(false);
  const [customBetSettledDate, setCustomBetSettledDate] = useState(false);

  const [platformSelected, setPlatformSelected] = useState(null);
  const [sportSelected, setSportSelected] = useState(null);
  const [betStatusSelected, setBetStatusSelected] = useState(null);
  const [betbuilderStatusSelected, setBetbuilderStatusSelected] = useState(null);
  const [operatorOptionsSelected, setOperatorOptionsSelected] = useState(null);
  const [systemOptionsSelected, setSystemOptionsSelected] = useState(null);
  const [userOptionsSelected, setUserOptionsSelected] = useState(null);
  const [oddTypeSelected, setOddTypeSelected] = useState(null);
  const [fixtureStatusSelected, setFixtureStatusSelected] = useState(null);
  const [fixtureDateFilterSelected, setFixtureDateFilterSelected] = useState(null);
  const [betDateFilterSelected, setBetDateFilterSelected] = useState(null);
  const [betbuilderDateFilterSelected, setBetbuilderDateFilterSelected] = useState(null);
  const [betSettledDateFilterSelected, setBetSettledDateFilterSelected] = useState(null);
  const [fixtureFromSelected, setFixtureFromSelected] = useState(null);
  const [fixtureToSelected, setFixtureToSelected] = useState(null);
  const [betFromSelected, setBetFromSelected] = useState(null);
  const [betToSelected, setBetToSelected] = useState(null);
  const [betbuilderFromSelected, setBetbuilderFromSelected] = useState(null);
  const [betbuilderToSelected, setBetbuilderToSelected] = useState(null);
  const [betSettledFromSelected, setBetSettledFromSelected] = useState(null);
  const [betSettledToSelected, setBetSettledToSelected] = useState(null);
  const [applyOn, setApplyOn] = useState(false);
  const [loading, setLoading] = useState(false);

  const [dateSelection, setDateSelection] = useState([
    { value: -100, label: "Select..." },
    { value: 1, label: "Today" },
    { value: -1, label: "Yesterday" },
    { value: -30, label: "Last 30 Days" },
    { value: -7, label: "Last 7 Days" },
    { value: 100, label: "Custom" },
  ]);

  const [fixtureStatus, setFixtureStatus] = useState([
    { value: -100, label: "Select..." },
    { value: 0, label: "All" },
    { value: 1, label: "In progress" },
    { value: 2, label: "Not started yet" },
    { value: 3, label: "Finished" },
    { value: 4, label: "Coverage lost" },
  ]);

  const [oddType, setOddType] = useState([
    { value: -100, label: "Select..." },
    { value: 0, label: "All" },
    { value: 1, label: "inPlay" },
    { value: 2, label: "preGame" },
  ]);

  const [betStatus, setBetStatus] = useState([
    { value: -100, label: "Select..." },
    { value: 0, label: "All" },
    { value: 1, label: "Settled" },
    { value: 2, label: "Unsettled" },
  ]);

  const [operatorOptions, setOperatorOptions] = useState([
    { value: -100, label: "Select..." },
    { value: 1, label: "Yes" },
    { value: 2, label: "No" },
  ]);

  const [systemOptions, setSystemOptions] = useState([
    { value: -100, label: "Select..." },
    { value: 0, label: "All" },
    { value: 1, label: "online" },
    { value: 2, label: "offline" },
  ]);
  const [userOptions, setUserOptions] = useState([
    { value: -100, label: "Select..." },
    { value: 100, label: "All" },
  ]);

  const [sports, setSports] = useState([]);

  const userData = getUserData();
  const platforms = userData
    ? userData.platforms
      ? userData.platforms.map((platform) => ({
          value: platform.id,
          label: platform.name,
          logo: platform.logo,
          sorting: platform.sorting,
          odds_styles: platform.odds_styles,
        }))
      : []
    : [];

  async function fetchData() {
    let getSportsEndpoint = `/api/v1/entities/allsports`;
    let getUsersEndpoint = `/api/v1/users/`;
    let response = await getData(getSportsEndpoint, { Authorization: getAuthorizationHeader() });
    if (response != null) {
      let sportsData = [{ value: 0, label: "All" }];
      sportsData = sportsData.concat(
        response.data.map((item) => {
          return { value: item.id, label: item.name };
        })
      );
      sportsList = sportsData;
      setSports(sportsData);
    }

    let userResponse = await getData(getUsersEndpoint, { Authorization: getAuthorizationHeader() });
    if (userResponse != null) {
      let usersData = [
        { value: -100, label: "Select..." },
        { value: 100, label: "All" },
      ];
      usersData = usersData.concat(
        userResponse.data.map((item) => {
          return { value: item.id, label: item.username };
        })
      );
      setUserOptions(usersData);
    }
  }

  const handleSelectionValueChange = (item, type) => {
    let filtersToSet = { ...filters };

    if (type == "platforms-filter") {
      //console.log("platform-filters: ", item);
      item.value = item.map((item) => {
        return item.value;
      });
      setPlatformSelected(item);
    }

    if (type == "sport-filter") {
      //console.log("sport-filter: ", item);
      item.value = item.map((item) => {
        return item.value;
      });
      setSportSelected(item);
    }

    if (type == "user-option") {
      //console.log("sport-filter: ", item);
      item.value = item.map((item) => {
        return item.value;
      });
      setUserOptionsSelected(item);
    }

    if (
      type == "bet-odd-uuid" ||
      type == "bet-id" ||
      type == "betbuilder-odd-uuid" ||
      type == "betbuilder-id" ||
      type == "fixture-id-filter" ||
      type == "fixture-uni-filter" ||
      type == "lemma-filter"
    ) {
      if (type == "bet-id" || type == "betbuilder-id") {
        if (!parseInt(item.currentTarget.value)) item.currentTarget.value = null;
      }
      item.value = item.currentTarget.value;
    }
    if (type == "fixture-from-date") {
      item.value = item[0];
      setFixtureFromSelected(item);
    }
    if (type == "bet-from-date") {
      item.value = item[0];
      setBetFromSelected(item);
    }
    if (type == "bet-settled-from-date") {
      item.value = item[0];
      setBetSettledFromSelected(item);
    }
    if (type == "fixture-to-date") {
      item.value = item[0];
      setFixtureToSelected(item);
    }
    if (type == "bet-to-date") {
      item.value = item[0];
      setBetToSelected(item);
    }
    if (type == "betbuilder-from-date") {
      item.value = item[0];
      setBetbuilderFromSelected(item);
    }
    if (type == "betbuilder-to-date") {
      item.value = item[0];
      setBetbuilderToSelected(item);
    }
    if (type == "bet-settled-to-date") {
      item.value = item[0];
      setBetSettledToSelected(item);
    }
    if (type == "odd-type-filter") {
      setOddTypeSelected(item);
    }
    if (type == "fixtures-status-filter") {
      setFixtureStatusSelected(item);
    }
    if (type == "bet-status") {
      setBetStatusSelected(item);
    }
    if (type == "betbuilder-status") {
      setBetbuilderStatusSelected(item);
    }

    if (type == "operator-option") {
      setOperatorOptionsSelected(item);
      if (item.value == -100) {
        filtersToSet[type] = undefined;
        filtersToSet["system-option"] = undefined;
        filtersToSet["user-option"] = undefined;
        setSystemOptionsSelected(null);
        setUserOptionsSelected(null);
      }
      if (item.value == 1) {
        setSystemOptionsSelected(null);
        filtersToSet[type] = item.value;
        filtersToSet["system-option"] = undefined;
      }
      if (item.value == 2) {
        setUserOptionsSelected(null);
        filtersToSet[type] = item.value;
        filtersToSet["user-option"] = undefined;
      }
      setFilters(filtersToSet);
      return;
    }

    if (type == "system-option") {
      setSystemOptionsSelected(item);
    }

    filtersToSet[type] = item.value;
    setFilters(filtersToSet);

    if (type == "fixture-date-filter") {
      if (item.value == 100) setCustomFixtureDate(true);
      if (item.value != 100) setCustomFixtureDate(false);
      setFixtureDateFilterSelected(item);
    }
    if (type == "bet-date-filter") {
      if (item.value == 100) setCustomBetDate(true);
      if (item.value != 100) setCustomBetDate(false);
      setBetDateFilterSelected(item);
    }
    if (type == "betbuilder-date-filter") {
      if (item.value == 100) setCustomBetbuilderDate(true);
      if (item.value != 100) setCustomBetbuilderDate(false);
      setBetbuilderDateFilterSelected(item);
    }
    if (type == "bet-settled-date-filter") {
      if (item.value == 100) setCustomBetSettledDate(true);
      if (item.value != 100) setCustomBetSettledDate(false);
      setBetSettledDateFilterSelected(item);
    }
  };

  const checkApplyDisable = () => {
    if (loading) {
      return true;
    }
    let disabled = true;
    let filtersToCheck = { ...filters };

    if (!Object.keys(filtersToCheck).length > 0) {
      disabled = true;
    } else {
      for (const key in filters) {
        if (Object.hasOwnProperty.call(filters, key)) {
          const filter = filters[key];
          if (typeof filter == "number") {
            if (filter == 100) {
              switch (filter) {
                case "bet-date-filter":
                  delete filtersToCheck["bet-date-filter"];
                  break;
                case "bet-settled-date-filter":
                  delete filtersToCheck["bet-settled-date-filter"];
                  break;
                case "fixture-date-filter":
                  delete filtersToCheck["fixture-date-filter"];
                  break;
                default:
                  break;
              }
            }

            if (filter != -100) {
              disabled = false;
              break;
            }
          }
          if (typeof filter == "string") {
            if (filter != "") {
              disabled = false;
              break;
            }
          }
          if (typeof filter == "object") {
            if (filter.length > 0) {
              disabled = false;
              break;
            }
          }
        }
      }
    }

    return disabled;
  };

  const handleApply = () => {
    setApplyOn(true);
    let filtersToSend = {
      platforms_filter: filters["platforms-filter"],
      fixture_date_filter: filters["fixture-date-filter"],
      fixture_from_date: filters["fixture-from-date"],
      fixture_to_date: filters["fixture-to-date"],
      odd_type_filter: filters["odd-type-filter"],
      fixtures_status_filter: filters["fixtures-status-filter"],
      fixture_id_filter: filters["fixture-id-filter"],
      fixture_uni_filter: filters["fixture-uni-filter"],
      sport_filter: filters["sport-filter"],
      bet_date_filter: filters["bet-date-filter"],
      bet_settled_date_filter: filters["bet-settled-date-filter"],
      bet_from_date: filters["bet-from-date"],
      bet_to_date: filters["bet-to-date"],
      betbuilder_date_filter: filters["betbuilder-date-filter"],
      betbuilder_from_date: filters["betbuilder-from-date"],
      betbuilder_to_date: filters["betbuilder-to-date"],
      bet_settled_from_date: filters["bet-settled-from-date"],
      bet_settled_to_date: filters["bet-settled-to-date"],
      bet_status: filters["bet-status"],
      betbuilder_status: filters["betbuilder-status"],
      bet_odd_uuid: filters["bet-odd-uuid"],
      betbuilder_odd_uuid: filters["betbuilder-odd-uuid"],
      bet_id: filters["bet-id"],
      betbuilder_id: filters["betbuilder-id"],
      operator_option: filters["operator-option"],
      user_option: filters["user-option"],
      system_option: filters["system-option"],
      lemma_filter: filters["lemma-filter"],
    };

    if (informParent && Object.keys(filters).length > 0) informParent(filtersToSend, false);
  };

  const handleReset = () => {
    setPlatformSelected(null);
    setSportSelected(null);
    setBetStatusSelected(null);
    setOddTypeSelected(null);
    setFixtureStatusSelected(null);
    setFixtureDateFilterSelected(null);
    setBetDateFilterSelected(null);
    setBetbuilderDateFilterSelected(null);
    setBetSettledDateFilterSelected(null);
    setFixtureFromSelected(null);
    setFixtureToSelected(null);
    setBetFromSelected(null);
    setBetToSelected(null);
    setBetbuilderFromSelected(null);
    setBetbuilderToSelected(null);
    setBetSettledFromSelected(null);
    setBetSettledToSelected(null);
    setBetbuilderStatusSelected(null);
    setCustomFixtureDate(false);
    setCustomBetDate(false);
    setCustomBetbuilderDate(false);
    setCustomBetSettledDate(false);
    setUserOptionsSelected(null);
    setSystemOptionsSelected(null);
    setOperatorOptionsSelected(null);

    document.getElementById("bet-id").value = null;
    document.getElementById("bet-odd-uuid").value = null;
    document.getElementById("betbuilder-id").value = null;
    document.getElementById("betbuilder-odd-uuid").value = null;
    document.getElementById("fixture-id-filter").value = null;
    document.getElementById("fixture-uni-filter").value = null;
    document.getElementById("lemma-filter").value = null;

    setFilters([]);
  };

  const handleAccordion = () => {
    setFiltersOpen((prev) => !prev);
  };

  useEffect(() => {
    setFiltersOpen(forceToggle);
    setApplyOn(false);
    //console.log("forceToogle: ", forceToggle);
  }, [forceToggle]);

  useEffect(() => {
    //console.log("loading...", loading, loadingData);
    setLoading(loadingData);
  }, [loadingData]);

  useEffect(() => {
    if (settlementOutcomes) setOutcomes(settlementOutcomes);
  }, [settlementOutcomes]);

  useEffect(() => {
    if (informParent && applyFilters != undefined && Object.keys(filters).length > 0) {
      let filtersToSend = {
        platforms_filter: filters["platforms-filter"],
        fixture_date_filter: filters["fixture-date-filter"],
        fixture_from_date: filters["fixture-from-date"],
        fixture_to_date: filters["fixture-to-date"],
        odd_type_filter: filters["odd-type-filter"],
        fixtures_status_filter: filters["fixtures-status-filter"],
        fixture_id_filter: filters["fixture-id-filter"],
        fixture_uni_filter: filters["fixture-uni-filter"],
        sport_filter: filters["sport-filter"],
        bet_date_filter: filters["bet-date-filter"],
        bet_settled_date_filter: filters["bet-settled-date-filter"],
        bet_from_date: filters["bet-from-date"],
        bet_to_date: filters["bet-to-date"],
        betbuilder_date_filter: filters["betbuilder-date-filter"],
        betbuilder_from_date: filters["betbuilder-from-date"],
        betbuilder_to_date: filters["betbuilder-to-date"],
        bet_settled_from_date: filters["bet-settled-from-date"],
        bet_settled_to_date: filters["bet-settled-to-date"],
        bet_status: filters["bet-status"],
        betbuilder_status: filters["betbuilder-status"],
        bet_odd_uuid: filters["bet-odd-uuid"],
        betbuilder_odd_uuid: filters["betbuilder-odd-uuid"],
        bet_id: filters["bet-id"],
        betbuilder_id: filters["betbuilder-id"],
        operator_option: filters["operator-option"],
        user_option: filters["user-option"],
        system_option: filters["system-option"],
        lemma_filter: filters["lemma-filter"],
      };
      informParent(filtersToSend, true);
    }
  }, [applyFilters]);

  useEffect(() => {
    if (!preLoadFilters || sportsList.length == 0) return;
    let filtersToSet = {};

    if (preLoadFilters.bet_id) {
      document.getElementById("bet-id").value = preLoadFilters.bet_id;
      filtersToSet["bet-id"] = preLoadFilters.bet_id;
    }
    if (preLoadFilters.betbuilder_id) {
      document.getElementById("betbuilder-id").value = preLoadFilters.betbuilder_id;
      filtersToSet["betbuilder-id"] = preLoadFilters.betbuilder_id;
    }
    if (preLoadFilters.provider_id) {
      document.getElementById("fixture-id-filter").value = preLoadFilters.provider_id;
      filtersToSet["fixture-id-filter"] = preLoadFilters.provider_id;
    }
    if (preLoadFilters.uni_id) {
      document.getElementById("fixture-uni-filter").value = preLoadFilters.uni_id;
      filtersToSet["fixture-uni-filter"] = preLoadFilters.uni_id;
    }
    if (preLoadFilters.sport_id) {
      let sport = sportsList.find((s) => s.value == preLoadFilters.sport_id);
      if (sport) {
        setSportSelected(sport);
        // document.getElementById("sport-filter").value = preLoadFilters.sport_id;
        filtersToSet["sport-filter"] = [preLoadFilters.sport_id];
      }
    }
    if (preLoadFilters.odd_uuid) {
      document.getElementById("bet-odd-uuid").value = preLoadFilters.odd_uuid;
      filtersToSet["bet-odd-uuid"] = preLoadFilters.odd_uuid;
    }
    if (preLoadFilters.betbuilder_odd_uuid) {
      document.getElementById("betbuilder-odd-uuid").value = preLoadFilters.betbuilder_odd_uuid;
      filtersToSet["betbuilder-odd-uuid"] = preLoadFilters.betbuilder_odd_uuid;
    }

    setFilters(filtersToSet);
  }, [preLoadFilters, sportsList]);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <SoftBox mb={3}>
      <Grid container spacing={0}>
        <Card style={{ width: "100%", overflow: "visible" }}>
          <Grid item xs={12} sx={{ paddingTop: "0px", height: "100%" }}>
            <div>
              <Accordion
                expanded={filtersOpen}
                onChange={handleAccordion}
                sx={{ boxShadow: "none", borderRadius: "20px !important" }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="settlement-filters-content"
                  id="settlement-filters-header"
                >
                  <Typography variant="h5">Filters</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={2} className="platform-filter-group">
                    <Grid item xs={6} md={6}>
                      <Typography variant="h5">Platform Section:</Typography>
                      <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                        <SoftTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          textTransform="capitalize"
                        >
                          Platforms
                        </SoftTypography>
                        <HtmlTooltip
                          placement="top"
                          title={
                            <React.Fragment>
                              <div style={{ display: "flex", flexWrap: "wrap" }}>
                                Select the Platform that you want to get bets from.
                              </div>
                            </React.Fragment>
                          }
                        >
                          <Icon className="info-icon-filters" title="">
                            info_outlined
                          </Icon>
                        </HtmlTooltip>
                      </SoftBox>
                      <SoftSelect
                        id="platforms-filter"
                        value={platformSelected}
                        isMulti={true}
                        options={platforms.map((entry) => ({
                          value: entry.value,
                          label: entry.label,
                        }))}
                        onChange={(item) => handleSelectionValueChange(item, "platforms-filter")}
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={6} md={6}>
                      <Typography variant="h5">Lemma Section:</Typography>
                      <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                        <SoftTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          textTransform="capitalize"
                        >
                          Text
                        </SoftTypography>
                        <HtmlTooltip
                          placement="top"
                          title={
                            <React.Fragment>
                              <div style={{ display: "flex", flexWrap: "wrap" }}>
                                Search in Participants name, Region, or Competition.
                              </div>
                            </React.Fragment>
                          }
                        >
                          <Icon className="info-icon-filters" title="">
                            info_outlined
                          </Icon>
                        </HtmlTooltip>
                      </SoftBox>
                      <SoftInput
                        id="lemma-filter"
                        size="small"
                        onChange={(item) => handleSelectionValueChange(item, "lemma-filter")}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={1} className="fixture-filter-group">
                    <Grid item xs={12} md={12}>
                      <Grid container>
                        <Grid item xs={12} md={12}>
                          <Typography variant="h5">Fixture Section:</Typography>
                        </Grid>
                        <Grid container spacing={1}>
                          <Grid item xs={3} md={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Date{" "}
                                <span
                                  style={{
                                    fontSize: "11px",
                                    color: "#cecece",
                                    fontWeight: "normal",
                                  }}
                                >
                                  (Fixture Start)
                                </span>
                              </SoftTypography>
                              <HtmlTooltip
                                placement="top"
                                title={
                                  <React.Fragment>
                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                      Select the Date that the Fixtures, that there are bets for,
                                      where scheduled to start.
                                    </div>
                                  </React.Fragment>
                                }
                              >
                                <Icon className="info-icon-filters" title="">
                                  info_outlined
                                </Icon>
                              </HtmlTooltip>
                            </SoftBox>
                            <SoftSelect
                              value={fixtureDateFilterSelected}
                              id="fixture-date-filter"
                              size="small"
                              options={dateSelection}
                              onChange={(item) =>
                                handleSelectionValueChange(item, "fixture-date-filter")
                              }
                            />
                          </Grid>
                          <Grid
                            item
                            xs={4}
                            md={4}
                            style={{ display: customFixtureDate ? "" : "none" }}
                          >
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                From{" "}
                                <span
                                  style={{
                                    fontSize: "11px",
                                    color: "#cecece",
                                    fontWeight: "normal",
                                  }}
                                >
                                  (Fixture Start)
                                </span>
                              </SoftTypography>
                              <HtmlTooltip
                                placement="top"
                                title={
                                  <React.Fragment>
                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                      Select the Date that the Fixtures, that there are bets for,
                                      where scheduled to start.
                                    </div>
                                  </React.Fragment>
                                }
                              >
                                <Icon className="info-icon-filters" title="">
                                  info_outlined
                                </Icon>
                              </HtmlTooltip>
                            </SoftBox>
                            <SoftDatePicker
                              value={fixtureFromSelected}
                              id="fixture-from-date"
                              size="small"
                              onChange={(item) =>
                                handleSelectionValueChange(item, "fixture-from-date")
                              }
                            />
                          </Grid>
                          <Grid
                            item
                            xs={4}
                            md={4}
                            style={{ display: customFixtureDate ? "" : "none" }}
                          >
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                To{" "}
                                <span
                                  style={{
                                    fontSize: "11px",
                                    color: "#cecece",
                                    fontWeight: "normal",
                                  }}
                                >
                                  (Fixture Start)
                                </span>
                              </SoftTypography>
                              <HtmlTooltip
                                placement="top"
                                title={
                                  <React.Fragment>
                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                      Select the Date that the Fixtures, that there are bets for,
                                      where scheduled to start.
                                    </div>
                                  </React.Fragment>
                                }
                              >
                                <Icon className="info-icon-filters" title="">
                                  info_outlined
                                </Icon>
                              </HtmlTooltip>
                            </SoftBox>
                            <SoftDatePicker
                              value={fixtureToSelected}
                              id="fixture-to-date"
                              size="small"
                              onChange={(item) =>
                                handleSelectionValueChange(item, "fixture-to-date")
                              }
                            />
                          </Grid>
                          <Grid item xs={9} md={9}>
                            <Grid container spacing={1}>
                              <Grid item xs={4} md={4}>
                                <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                  <SoftTypography
                                    component="label"
                                    variant="caption"
                                    fontWeight="bold"
                                    textTransform="capitalize"
                                  >
                                    Status{" "}
                                    <span
                                      style={{
                                        fontSize: "11px",
                                        color: "#cecece",
                                        fontWeight: "normal",
                                      }}
                                    >
                                      (In progress etc.)
                                    </span>
                                  </SoftTypography>
                                  <HtmlTooltip
                                    placement="top"
                                    maxwidth={200}
                                    title={
                                      <React.Fragment>
                                        <div style={{ display: "flex", flexWrap: "wrap" }}>
                                          Select the Status of the Fixture that have bets placed.
                                        </div>
                                      </React.Fragment>
                                    }
                                  >
                                    <Icon className="info-icon-filters" title="">
                                      info_outlined
                                    </Icon>
                                  </HtmlTooltip>
                                </SoftBox>
                                <SoftSelect
                                  value={fixtureStatusSelected}
                                  id="fixtures-status-filter"
                                  size="small"
                                  options={fixtureStatus}
                                  onChange={(item) =>
                                    handleSelectionValueChange(item, "fixtures-status-filter")
                                  }
                                />
                              </Grid>
                              <Grid item xs={2} md={2}>
                                <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                  <SoftTypography
                                    component="label"
                                    variant="caption"
                                    fontWeight="bold"
                                    textTransform="capitalize"
                                  >
                                    Provider id
                                  </SoftTypography>
                                  <HtmlTooltip
                                    placement="top"
                                    title={
                                      <React.Fragment>
                                        <div style={{ display: "flex", flexWrap: "wrap" }}>
                                          This is the Provider Fixture Id.
                                        </div>
                                      </React.Fragment>
                                    }
                                  >
                                    <Icon className="info-icon-filters" title="">
                                      info_outlined
                                    </Icon>
                                  </HtmlTooltip>
                                </SoftBox>
                                <SoftInput
                                  id="fixture-id-filter"
                                  size="small"
                                  onChange={(item) =>
                                    handleSelectionValueChange(item, "fixture-id-filter")
                                  }
                                />
                              </Grid>
                              <Grid item xs={2} md={2}>
                                <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                  <SoftTypography
                                    component="label"
                                    variant="caption"
                                    fontWeight="bold"
                                    textTransform="capitalize"
                                  >
                                    UNI id
                                  </SoftTypography>
                                  <HtmlTooltip
                                    placement="top"
                                    title={
                                      <React.Fragment>
                                        <div style={{ display: "flex", flexWrap: "wrap" }}>
                                          This is the UNI Fixture Id.
                                        </div>
                                      </React.Fragment>
                                    }
                                  >
                                    <Icon className="info-icon-filters" title="">
                                      info_outlined
                                    </Icon>
                                  </HtmlTooltip>
                                </SoftBox>
                                <SoftInput
                                  id="fixture-uni-filter"
                                  size="small"
                                  onChange={(item) =>
                                    handleSelectionValueChange(item, "fixture-uni-filter")
                                  }
                                />
                              </Grid>
                              <Grid item xs={2} md={2}>
                                <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                  <SoftTypography
                                    component="label"
                                    variant="caption"
                                    fontWeight="bold"
                                    textTransform="capitalize"
                                  >
                                    Sports
                                  </SoftTypography>
                                  <HtmlTooltip
                                    placement="top"
                                    title={
                                      <React.Fragment>
                                        <div style={{ display: "flex", flexWrap: "wrap" }}>
                                          Select the Sports you want to list the bets from.
                                        </div>
                                      </React.Fragment>
                                    }
                                  >
                                    <Icon className="info-icon-filters" title="">
                                      info_outlined
                                    </Icon>
                                  </HtmlTooltip>
                                </SoftBox>
                                <SoftSelect
                                  value={sportSelected}
                                  id="sport-filter"
                                  size="small"
                                  options={sports}
                                  isMulti={true}
                                  onChange={(item) =>
                                    handleSelectionValueChange(item, "sport-filter")
                                  }
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid container spacing={1} className="bet-filter-group">
                    <Grid item xs={12} md={12}>
                      <Grid container>
                        <Grid item xs={12} md={12}>
                          <Typography variant="h5">Bet Section:</Typography>
                        </Grid>
                        <Grid container spacing={1}>
                          <Grid item xs={3} md={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Date{" "}
                                <span
                                  style={{
                                    fontSize: "11px",
                                    color: "#cecece",
                                    fontWeight: "normal",
                                  }}
                                >
                                  (Bet placed)
                                </span>
                              </SoftTypography>
                              <HtmlTooltip
                                placement="top"
                                title={
                                  <React.Fragment>
                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                      Select the Date that the bets placed.
                                    </div>
                                  </React.Fragment>
                                }
                              >
                                <Icon className="info-icon-filters" title="">
                                  info_outlined
                                </Icon>
                              </HtmlTooltip>
                            </SoftBox>
                            <SoftSelect
                              value={betDateFilterSelected}
                              id="bet-date-filter"
                              size="small"
                              options={dateSelection}
                              onChange={(item) =>
                                handleSelectionValueChange(item, "bet-date-filter")
                              }
                            />
                          </Grid>
                          <Grid item xs={3} md={3} style={{ display: customBetDate ? "" : "none" }}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                From{" "}
                                <span
                                  style={{
                                    fontSize: "11px",
                                    color: "#cecece",
                                    fontWeight: "normal",
                                  }}
                                >
                                  (Bet placed)
                                </span>
                              </SoftTypography>
                              <HtmlTooltip
                                placement="top"
                                title={
                                  <React.Fragment>
                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                      Select the Date that the bets placed.
                                    </div>
                                  </React.Fragment>
                                }
                              >
                                <Icon className="info-icon-filters" title="">
                                  info_outlined
                                </Icon>
                              </HtmlTooltip>
                            </SoftBox>
                            <SoftDatePicker
                              value={betFromSelected}
                              id="bet-from-date"
                              size="small"
                              onChange={(item) => handleSelectionValueChange(item, "bet-from-date")}
                            />
                          </Grid>
                          <Grid item xs={3} md={3} style={{ display: customBetDate ? "" : "none" }}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                To{" "}
                                <span
                                  style={{
                                    fontSize: "11px",
                                    color: "#cecece",
                                    fontWeight: "normal",
                                  }}
                                >
                                  (Bet placed)
                                </span>
                              </SoftTypography>
                              <HtmlTooltip
                                placement="top"
                                title={
                                  <React.Fragment>
                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                      Select the Date that the bets placed.
                                    </div>
                                  </React.Fragment>
                                }
                              >
                                <Icon className="info-icon-filters" title="">
                                  info_outlined
                                </Icon>
                              </HtmlTooltip>
                            </SoftBox>
                            <SoftDatePicker
                              value={betToSelected}
                              id="bet-to-date"
                              size="small"
                              onChange={(item) => handleSelectionValueChange(item, "bet-to-date")}
                            />
                          </Grid>
                          <Grid item xs={3} md={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Status
                              </SoftTypography>
                              <HtmlTooltip
                                placement="top"
                                title={
                                  <React.Fragment>
                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                      Select the Status of the Bet you want to list.
                                    </div>
                                  </React.Fragment>
                                }
                              >
                                <Icon className="info-icon-filters" title="">
                                  info_outlined
                                </Icon>
                              </HtmlTooltip>
                            </SoftBox>
                            <SoftSelect
                              sx={{ backgroundColor: "#fff" }}
                              value={betStatusSelected}
                              id="bet-status"
                              size="small"
                              options={betStatus}
                              onChange={(item) => handleSelectionValueChange(item, "bet-status")}
                            />
                          </Grid>
                          <Grid item xs={2} md={2}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Bet Id
                              </SoftTypography>
                              <HtmlTooltip
                                placement="top"
                                title={
                                  <React.Fragment>
                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                      This is the Id of the Bet you want to list.
                                    </div>
                                  </React.Fragment>
                                }
                              >
                                <Icon className="info-icon-filters" title="">
                                  info_outlined
                                </Icon>
                              </HtmlTooltip>
                            </SoftBox>
                            <SoftInput
                              id="bet-id"
                              size="small"
                              onChange={(item) => handleSelectionValueChange(item, "bet-id")}
                            />
                          </Grid>
                          <Grid item xs={2} md={2}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Bet Odd uuid
                              </SoftTypography>
                              <HtmlTooltip
                                placement="top"
                                title={
                                  <React.Fragment>
                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                      This is the UUID of the odd that has been placed bet for.
                                    </div>
                                  </React.Fragment>
                                }
                              >
                                <Icon className="info-icon-filters" title="">
                                  info_outlined
                                </Icon>
                              </HtmlTooltip>
                            </SoftBox>
                            <SoftInput
                              id="bet-odd-uuid"
                              size="small"
                              onChange={(item) => handleSelectionValueChange(item, "bet-odd-uuid")}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid container spacing={1} className="betbuilder-filter-group">
                    <Grid item xs={12} md={12}>
                      <Grid container>
                        <Grid item xs={12} md={12}>
                          <Typography variant="h5">Betbuilder Section:</Typography>
                        </Grid>
                        <Grid container spacing={1}>
                          <Grid item xs={3} md={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Date{" "}
                                <span
                                  style={{
                                    fontSize: "11px",
                                    color: "#cecece",
                                    fontWeight: "normal",
                                  }}
                                >
                                  (Betbuilder placed)
                                </span>
                              </SoftTypography>
                              <HtmlTooltip
                                placement="top"
                                title={
                                  <React.Fragment>
                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                      Select the Date that the betbuilders placed.
                                    </div>
                                  </React.Fragment>
                                }
                              >
                                <Icon className="info-icon-filters" title="">
                                  info_outlined
                                </Icon>
                              </HtmlTooltip>
                            </SoftBox>
                            <SoftSelect
                              value={betbuilderDateFilterSelected}
                              id="betbuilder-date-filter"
                              size="small"
                              options={dateSelection}
                              onChange={(item) =>
                                handleSelectionValueChange(item, "betbuilder-date-filter")
                              }
                            />
                          </Grid>
                          <Grid
                            item
                            xs={3}
                            md={3}
                            style={{ display: customBetbuilderDate ? "" : "none" }}
                          >
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                From{" "}
                                <span
                                  style={{
                                    fontSize: "11px",
                                    color: "#cecece",
                                    fontWeight: "normal",
                                  }}
                                >
                                  (Betbuilder placed)
                                </span>
                              </SoftTypography>
                              <HtmlTooltip
                                placement="top"
                                title={
                                  <React.Fragment>
                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                      Select the Date that the betbuilders placed.
                                    </div>
                                  </React.Fragment>
                                }
                              >
                                <Icon className="info-icon-filters" title="">
                                  info_outlined
                                </Icon>
                              </HtmlTooltip>
                            </SoftBox>
                            <SoftDatePicker
                              value={betbuilderFromSelected}
                              id="betbuilder-from-date"
                              size="small"
                              onChange={(item) =>
                                handleSelectionValueChange(item, "betbuilder-from-date")
                              }
                            />
                          </Grid>
                          <Grid
                            item
                            xs={3}
                            md={3}
                            style={{ display: customBetbuilderDate ? "" : "none" }}
                          >
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                To{" "}
                                <span
                                  style={{
                                    fontSize: "11px",
                                    color: "#cecece",
                                    fontWeight: "normal",
                                  }}
                                >
                                  (Betbuilder placed)
                                </span>
                              </SoftTypography>
                              <HtmlTooltip
                                placement="top"
                                title={
                                  <React.Fragment>
                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                      Select the Date that the betbuilders placed.
                                    </div>
                                  </React.Fragment>
                                }
                              >
                                <Icon className="info-icon-filters" title="">
                                  info_outlined
                                </Icon>
                              </HtmlTooltip>
                            </SoftBox>
                            <SoftDatePicker
                              value={betbuilderToSelected}
                              id="betbuilder-to-date"
                              size="small"
                              onChange={(item) =>
                                handleSelectionValueChange(item, "betbuilder-to-date")
                              }
                            />
                          </Grid>
                          <Grid item xs={3} md={3}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Status
                              </SoftTypography>
                              <HtmlTooltip
                                placement="top"
                                title={
                                  <React.Fragment>
                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                      Select the Status of the Betbuilder you want to list.
                                    </div>
                                  </React.Fragment>
                                }
                              >
                                <Icon className="info-icon-filters" title="">
                                  info_outlined
                                </Icon>
                              </HtmlTooltip>
                            </SoftBox>
                            <SoftSelect
                              sx={{ backgroundColor: "#fff" }}
                              value={betbuilderStatusSelected}
                              id="betbuilder-status"
                              size="small"
                              options={betStatus}
                              onChange={(item) =>
                                handleSelectionValueChange(item, "betbuilder-status")
                              }
                            />
                          </Grid>
                          <Grid item xs={2} md={2}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Betbuilder Id
                              </SoftTypography>
                              <HtmlTooltip
                                placement="top"
                                title={
                                  <React.Fragment>
                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                      This is the Id of the Betbuilder you want to list.
                                    </div>
                                  </React.Fragment>
                                }
                              >
                                <Icon className="info-icon-filters" title="">
                                  info_outlined
                                </Icon>
                              </HtmlTooltip>
                            </SoftBox>
                            <SoftInput
                              id="betbuilder-id"
                              size="small"
                              onChange={(item) => handleSelectionValueChange(item, "betbuilder-id")}
                            />
                          </Grid>
                          <Grid item xs={2} md={2}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Bet Odd uuid
                              </SoftTypography>
                              <HtmlTooltip
                                placement="top"
                                title={
                                  <React.Fragment>
                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                      This is the UUID of the odd that has been placed betbuilder for.
                                    </div>
                                  </React.Fragment>
                                }
                              >
                                <Icon className="info-icon-filters" title="">
                                  info_outlined
                                </Icon>
                              </HtmlTooltip>
                            </SoftBox>
                            <SoftInput
                              id="betbuilder-odd-uuid"
                              size="small"
                              onChange={(item) =>
                                handleSelectionValueChange(item, "betbuilder-odd-uuid")
                              }
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid container spacing={1} className="settlement-filter-group">
                    <Grid item xs={12} md={12}>
                      <Grid container>
                        <Grid item xs={12} md={12}>
                          <Typography variant="h5">Settlement Section:</Typography>
                        </Grid>
                        <Grid container spacing={1}>
                          <Grid item xs={2} md={2}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Date{" "}
                                <span
                                  style={{
                                    fontSize: "11px",
                                    color: "#cecece",
                                    fontWeight: "normal",
                                  }}
                                >
                                  (Bet settled)
                                </span>
                              </SoftTypography>
                              <HtmlTooltip
                                placement="top"
                                title={
                                  <React.Fragment>
                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                      Select the Date that the bets settled.
                                    </div>
                                  </React.Fragment>
                                }
                              >
                                <Icon className="info-icon-filters" title="">
                                  info_outlined
                                </Icon>
                              </HtmlTooltip>
                            </SoftBox>
                            <SoftSelect
                              value={betSettledDateFilterSelected}
                              id="bet-settled-date-filter"
                              size="small"
                              options={dateSelection}
                              onChange={(item) =>
                                handleSelectionValueChange(item, "bet-settled-date-filter")
                              }
                            />
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            md={2}
                            style={{ display: customBetSettledDate ? "" : "none" }}
                          >
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                From{" "}
                                <span
                                  style={{
                                    fontSize: "11px",
                                    color: "#cecece",
                                    fontWeight: "normal",
                                  }}
                                >
                                  (Bet settled)
                                </span>
                              </SoftTypography>
                              <HtmlTooltip
                                placement="top"
                                title={
                                  <React.Fragment>
                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                      Select the Date that the bets settled.
                                    </div>
                                  </React.Fragment>
                                }
                              >
                                <Icon className="info-icon-filters" title="">
                                  info_outlined
                                </Icon>
                              </HtmlTooltip>
                            </SoftBox>
                            <SoftDatePicker
                              value={betSettledFromSelected}
                              id="bet-settled-from-date"
                              size="small"
                              enableTime={true}
                              onChange={(item) =>
                                handleSelectionValueChange(item, "bet-settled-from-date")
                              }
                            />
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            md={2}
                            style={{ display: customBetSettledDate ? "" : "none" }}
                          >
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                To{" "}
                                <span
                                  style={{
                                    fontSize: "11px",
                                    color: "#cecece",
                                    fontWeight: "normal",
                                  }}
                                >
                                  (Bet settled)
                                </span>
                              </SoftTypography>
                              <HtmlTooltip
                                placement="top"
                                title={
                                  <React.Fragment>
                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                      Select the Date that the bets settled.
                                    </div>
                                  </React.Fragment>
                                }
                              >
                                <Icon className="info-icon-filters" title="">
                                  info_outlined
                                </Icon>
                              </HtmlTooltip>
                            </SoftBox>
                            <SoftDatePicker
                              value={betSettledToSelected}
                              id="bet-settled-to-date"
                              size="small"
                              enableTime={true}
                              onChange={(item) =>
                                handleSelectionValueChange(item, "bet-settled-to-date")
                              }
                            />
                          </Grid>
                          <Grid item xs={2} md={2}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Operator:
                              </SoftTypography>
                              <HtmlTooltip
                                placement="top"
                                title={
                                  <React.Fragment>
                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                      Select the Status of the Bet you want to list.
                                    </div>
                                  </React.Fragment>
                                }
                              >
                                <Icon className="info-icon-filters" title="">
                                  info_outlined
                                </Icon>
                              </HtmlTooltip>
                            </SoftBox>
                            <SoftSelect
                              sx={{ backgroundColor: "#fff" }}
                              value={operatorOptionsSelected}
                              id="operator-option"
                              size="small"
                              options={operatorOptions}
                              onChange={(item) =>
                                handleSelectionValueChange(item, "operator-option")
                              }
                            />
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            md={2}
                            sx={{
                              display:
                                operatorOptionsSelected && operatorOptionsSelected.value == 1
                                  ? ""
                                  : "none",
                            }}
                          >
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Username:
                              </SoftTypography>
                              <HtmlTooltip
                                placement="top"
                                title={
                                  <React.Fragment>
                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                      Select the Status of the Bet you want to list.
                                    </div>
                                  </React.Fragment>
                                }
                              >
                                <Icon className="info-icon-filters" title="">
                                  info_outlined
                                </Icon>
                              </HtmlTooltip>
                            </SoftBox>
                            <SoftSelect
                              sx={{ backgroundColor: "#fff" }}
                              isMulti={true}
                              value={userOptionsSelected}
                              id="user-option"
                              size="small"
                              options={userOptions}
                              onChange={(item) => handleSelectionValueChange(item, "user-option")}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            md={2}
                            sx={{
                              display:
                                operatorOptionsSelected && operatorOptionsSelected.value == 2
                                  ? ""
                                  : "none",
                            }}
                          >
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                System:
                              </SoftTypography>
                              <HtmlTooltip
                                placement="top"
                                title={
                                  <React.Fragment>
                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                      Select the Status of the Bet you want to list.
                                    </div>
                                  </React.Fragment>
                                }
                              >
                                <Icon className="info-icon-filters" title="">
                                  info_outlined
                                </Icon>
                              </HtmlTooltip>
                            </SoftBox>
                            <SoftSelect
                              sx={{ backgroundColor: "#fff" }}
                              value={systemOptionsSelected}
                              id="system-option"
                              size="small"
                              options={systemOptions}
                              onChange={(item) => handleSelectionValueChange(item, "system-option")}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid my={2}>
                    <hr style={{ color: "rgb(236, 236, 236)", border: "0.5px solid" }} />
                  </Grid>
                  <Grid container spacing={1} display="flex" alignItems="flex-end">
                    <Grid item style={{ width: "75%" }}></Grid>
                    <Grid item>
                      <SoftButton color="light" onClick={handleReset}>
                        Reset
                      </SoftButton>
                    </Grid>
                    <Grid item>
                      <SoftButton color="dark" onClick={handleApply} disabled={checkApplyDisable()}>
                        Apply
                        <LoopIcon
                          style={{ display: loading ? "" : "none" }}
                          sx={{
                            animation: "spin 2s linear infinite",
                            "@keyframes spin": {
                              "0%": {
                                transform: "rotate(360deg)",
                              },
                              "100%": {
                                transform: "rotate(0deg)",
                              },
                            },
                          }}
                        />
                      </SoftButton>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </div>
          </Grid>
        </Card>
      </Grid>
    </SoftBox>
  );
}

AdvancedSettlementFilters.propTypes = {
  applyFilters: PropTypes.bool,
  settlementOutcomes: PropTypes.array,
  informParent: PropTypes.func,
  forceToggle: PropTypes.bool,
  loadingData: PropTypes.bool,
  preLoadFilters: PropTypes.object,
};

export default AdvancedSettlementFilters;
